<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Add Material Depreciation Percentage</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
         <v-row justify="center" dense>
        <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                <v-radio label="Material Wise" value="material" color="#0f2027"></v-radio>
                <v-radio label="Material Category Wise" value="material_category" color="#0f2027"></v-radio>
            </v-radio-group>
        </v-row>


          <v-row justify="center" dense>
            <v-col cols="12" sm="12">
           <v-card class="box" v-if="radios == 'material'">
             <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Material Wise
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
              <v-row justify="center" dense>
                 <v-col cols="12" sm="3">
            <p><b>Financial Year*</b></p>
                <v-autocomplete
                color="#0F2027"
                dense
                rounded
                required
                v-model="ay"
                :items="ay_list"
                item-text="ay"
                item-value="id"
                label="Financial Year"
                outlined
                />
        </v-col>
          <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Depreciation Cycle</b></p>
            <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="inv_depreciation_cycle"
            :items="inv_depreciation_cycle_list"
            item-text="name_of_cycle"
            item-value="id"
            label="Depreciation Cycle"
            return-object
            outlined
            @change="setData()"
            />
        </v-col>
       
    </v-row>
      <v-row justify="center" dense v-if="inv_depreciation_cycle">
          <v-col cols="12" sm="3">
            <p><b>Depreciation Cycle From Date</b></p>
             <v-text-field
              outlined
              dense
              rounded
              type="text"
              v-model="from_date"
              disabled
            ></v-text-field>
        </v-col>
         <v-col cols="12" sm="3">
            <p><b>Depreciation Cycle To Date</b></p>
             <v-text-field
              outlined
              dense
              rounded
              type="text"
              v-model="to_date"
              disabled
            ></v-text-field>
        </v-col>
      </v-row>

        <v-row justify="center" dense v-if="inv_depreciation_cycle">
             <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Material</b></p>
            <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="inventory_material"
            :items="inventory_material_list"
            item-text="name"
            item-value="id"
            label="Material"
            outlined
            return-object
            @change="setData2();getMaterialPartListByMaterial()"
            />
        </v-col>
          <v-col cols="12" sm="3" v-if="inventory_material">
        <p><b>Material Set</b></p>
             <v-text-field
              outlined
              dense
              rounded
              type="text"
              v-model="material_set"
              disabled
            ></v-text-field>
        </v-col>
        {{inventory_material_part_list}}
        </v-row>



           </v-card>
            </v-col>
          <v-col cols="12" sm="12">
             <v-card class="box" v-if="radios == 'material_category'">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                           Material Category Wise
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                 <v-row justify="center" dense>
                      <v-col cols="12" sm="3">
                      </v-col>
                 </v-row>
            </v-card>  
          </v-col>
        </v-row>

        
        <!-- <v-row justify="center" dense v-if="inventory_material && part_name && part_code">
          <v-btn color="warning" @click="saveInventoryMaterialPart()" :loading="loader"
            >Add</v-btn
          >
        </v-row> -->
       </v-card>

     <!-- <v-card class="box" v-if="inventory_material_part_list!='' ">
     <v-data-table  :headers="headers" :items="inventory_material_part_list" :items-per-page="-1">
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Inventory Material Part List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
         <template v-slot:[`item.isactive`]="{ item }">
                 <v-switch v-model="item.isactive"  @change="toggleIsactiveInventoryInventoryMaterialPart(item)"
                 :color="item.isactive ? 'success' : 'primary'"></v-switch>
      </template>
       <template v-slot:[`item.delete`]="{ item }">
            <v-avatar size="35">
              <v-icon
                class="mr-4 v-icon-size"
                color="red"
                @click="deleteInventoryInventoryMaterialPart(item)"
                >mdi-trash-can</v-icon
              >
            </v-avatar>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-avatar size="35">
              <v-icon
                class="mr-4 v-icon-size"
                color="red"
                @click="editDetail(item)"
                >mdi-pencil</v-icon
              >
            </v-avatar>
          </template>
           <template v-slot:[`item.islast`]="{ item }">
            <span v-if="item.islast">
              <v-icon class="mr-2 v-icon-size" color="success"
                >mdi-check-circle-outline</v-icon
              >
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error"
                >mdi-close-circle-outline</v-icon
              >
            </span>
          </template>
     </v-data-table>
 </v-card> -->

         <v-dialog
        v-model="dialog_edit"
        persistent
        scrollable="false"
        max-width="1200px"
        transition="dialog-bottom-transition"
      >
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Edit Material Specification</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <br>
            <v-row justify="center" dense>
            <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Material</b></p>
                <v-autocomplete
                color="#0F2027"
                dense
                rounded
                required
                v-model="editedItem.inventory_material"
                :items="inventory_material_list"
                item-text="name"
                item-value="id"
                label="Material"
                outlined
                disabled
                />
        </v-col>
        </v-row>
        <v-row justify="center" dense >
            <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Material Part Name</b></p>
             <v-text-field
              outlined
              dense
              rounded
              type="text"
              v-model="editedItem.part_name"
            ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Material Part Code</b></p>
             <v-text-field
              outlined
              dense
              rounded
              type="text"
              v-model="editedItem.part_code"
            ></v-text-field>
        </v-col>
         <v-col cols="12" sm="3">
            <p><b>Specification</b></p>
             <v-text-field
              outlined
              dense
              rounded
              type="text"
              v-model="editedItem.specification"
            ></v-text-field>
        </v-col>
        </v-row>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn color="primary" :loading="loader" @click="saveUpdateInventoryInventoryMaterialPart()"
              >Update</v-btn
            >
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialog_edit = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      inventory_material_list:[],inventory_material:"",
      ay_list:[],ay:"",
      inv_depreciation_cycle_list:[],inv_depreciation_cycle:"",
      inv_material_category_list:[],inv_material_category:"",
      from_date:"",to_date:"",material_set:"",
      headers:[
      { text: "SR No", value: "srno" },
      { text: "Material", value: "invmaterial" },
      { text: "Name", value: "name" },
      { text: "Code", value: "code" },
      { text: "Specification", value: "specification" },
      { text: "Is Active", value: "isactive" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" },
      ],
    dialog_edit: false,
    editedItem: {
      id: "",specification:"",inventory_material:"",part_name:"",part_code:""
    },
    radios:null,
  }),
   methods: {
      setData2(){
            this.material_set=this.inventory_material.invmaterialset
      },
      setData(){
            this.from_date=this.inv_depreciation_cycle.from_date
            this.to_date=this.inv_depreciation_cycle.to_date
      },
      clearData(){
        this.part_name="",this.inventory_material="",this.specification="",this.part_code=""
      },
      async saveUpdateInventoryInventoryMaterialPart(){
       this.overlay = true;
       this.loader = true;
        try {
          const res = await axios.post("/Inventory/saveUpdateInventoryInventoryMaterialPart", this.editedItem);
          if (res.data.flag == "YES") {
            this.inventory_material_part_list=res.data.inventory_material_part_list
            this.showSnackbar("green", "Updated Successfully"); // show snackbar  
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
         this.dialog_edit = false;
      }
    },
    editDetail(item) {
      this.editedItem.id = item.id;
      this.editedItem.specification = item.specification;
      this.editedItem.part_name = item.name;
      this.editedItem.part_code = item.code;
      this.editedItem.inventory_material = item.invmaterial_id;
      this.dialog_edit = true;
    },
    async saveInventoryMaterialPart(){
        const data = {
        inventory_material:this.inventory_material,
        specification:this.specification,
        part_name:this.part_name,
        part_code:this.part_code,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/saveInventoryMaterialPart", data);
          if (res.data.flag == "YES") {
            this.inventory_material_part_list=res.data.inventory_material_part_list
            this.showSnackbar("green", "Saved Successfully"); // show snackbar   
            this.clearData();
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async getMaterialPartListByMaterial(){
        const data = {
            id: this.inventory_material.id,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/getMaterialPartListByMaterial", data);
          if (res.data.flag == "YES") {
             this.inventory_material_part_list=res.data.inventory_material_part_list
            //this.showSnackbar("green", "Updated Successfully"); // show snackbar    
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async toggleIsactiveInventoryInventoryMaterialPart(item){
        const data = {
            id: item.id,
            isactive: item.isactive,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/toggleIsactiveInventoryInventoryMaterialPart", data);
          if (res.data.flag == "YES") {
             this.inventory_material_part_list=res.data.inventory_material_part_list
            this.showSnackbar("green", "Updated Successfully"); // show snackbar    
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async deleteInventoryInventoryMaterialPart(item){
       if (!confirm("Are You Sure You Want To Delete This Item?"))
        return;
        const data = {
            id: item.id,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/deleteInventoryInventoryMaterialPart", data);
          if (res.data.flag == "YES") {
             this.showSnackbar("green", "Deleted Successfully"); // show snackbar    
             this.inventory_material_part_list=res.data.inventory_material_part_list
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
    async onLoad() {
      try {
          const res = await axios.post("/Inventory/getMaterialDepreciationPercentageList");
          if (res.data.flag == "YES") {
            this.inventory_material_list=res.data.inventory_material_list
            this.inv_depreciation_cycle_list=res.data.inv_depreciation_cycle_list
            this.ay_list=res.data.ay_list
            this.ay=res.data.cay
            this.inv_material_category_list=res.data.inv_material_category_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>